import React, { useState, useEffect, useContext, useRef } from "react";
import AdminContext from "../../../StateContext/Application";
// import { apiurl } from '../../../../path';
// import "./rejectpanel.css";
import { apiurl } from "../../../../../path";
import {
  Time32,
  UpdateWhite32,
  Excel32,
  JPG32,
  PNG32,
  AddFile32,
  VendorName32,
  Bank32,
  barely_black_bg_img,
  Cancel32,
  Email32,
  Location32,
  PhoneNumber32,
  submit,
   Edit32WHITE,
   Approved32 ,
   PDF32
} from "../../../../../public/LoginImages/importimages";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
// 21-09
import DemandGeneration from "../DemandGeneration/DemandGeneration"; 
import html2canvas from "html2canvas";



// 08-10 status color
const STATUS_STYLES = {
  pending: {
    label: "Pending",
    color: "#F59E0B",
    textColor: "#E8890C",
    bg: "#FFFFFF",
    img: "/Pending icon 32 Size.png",
  },
  sendback: {
    label: "Send Back",
    color: "#0D6EFD",
    textColor: "#0D6EFD",
    bg: "#FFFFFF",
    img: "/send back 32 size.png",
  },
  approved: {
    label: "Approved",
    color: "#39B54A",
    textColor: "#39B54A",
    bg: "#FFFFFF",
    img: "/Approved  32 Size.png",
  },
  rejected: {
    label: "Rejected",
    color: "#FF5C6C",
    textColor: "#FF5C6C",
    bg: "#FFFFFF",
    img: "/Reject 32 size.png",
  },
    generated: {
    label: "Generated",
    color: "#39B54A",
    textColor: "#39B54A",
    bg: "#FFFFFF",
    img: "/Approved  32 Size.png",
  },
 
};
 
const StatusBadge = ({ status }) => {
  const key = (status || "").replace(/\s+/g, "").toLowerCase();
 
  const s = STATUS_STYLES[key] || STATUS_STYLES.pending;
 
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        minWidth: "95px",
        padding: "5px 12px",
        border: `1px solid ${s.color}`,
        borderRadius: "20px",
        color: s.textColor,
        backgroundColor: s.bg,
        fontSize: "12px",
        fontWeight: "600",
        whiteSpace: "nowrap",
      }}
    >
      <img
        src={s.img}
        alt={s.label}
        style={{ width: "18px", height: "18px", objectFit: "contain" }}
      />
      {s.label}
    </span>
  );
};
 
 
 
 

const ViewDemandGeneration = () => {
  const context = useContext(AdminContext);
  const { GetBudgetHeadInfo, GetVendorBillsAndDeduction, Usermenu, ApproveBills } = context;
const [listLoading, setListLoading] = useState(true);//19-10
  const [technicalInwards, setTechnicalInwards] = useState([]);
  const [selectedBills, setSelectedBills] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [filteredBills2, setFilteredBills2] = useState([]);
// 21-09
const [showEditForm, setShowEditForm] = useState(false);
const [editBillData, setEditBillData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
 const [statusFilter, setStatusFilter] = useState("All");
  const [
    fetchSpecificDemandDeductionDetail,
    setfetchSpecficDemandDeductionDetail,
  ] = useState([]);
  const [showspecific, setShowSpecific] = useState(0);
  const [selectedDemandID, setSelectedDemandID] = useState(null);
  const [selectedBillData, setselectedBillData] = useState(null);

  const [AdminData, setAdminData] = useState([]);
  const [userDistrict, setuserDistrict] = useState("");
  const [exportingBillSlipPDF, setExportingBillSlipPDF] = useState(false);
  const [exportingPDF, setExportingPDF] = useState(false);
  const [loading, setloading] = useState(false);
const [deductionList, setDeductionList] = useState([]);
  const billSlipRef = useRef(null);

  const GetAdminData = async () => {
    try {
      let res = await Usermenu();
      console.log("res", res);

      setAdminData(res.Data);
      setuserDistrict(res?.Data?.District);
    } catch (err) {
      console.log(err);
    }
  };
  // 21-09
  const isMaker =
  AdminData?.Department_Name === "New Agency Maker" &&
  AdminData?.Role === "New Agency Maker";


  useEffect(() => {
  GetAdminData();
}, []);

  const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  //const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);
  const currentBills = Array.isArray(filteredBills)
    ? filteredBills.slice(indexOfFirstBill, indexOfLastBill)
    : [];


const getDemandGenerationList = async () => {
   setListLoading(true);
  try {
    const data = await GetBudgetHeadInfo(
      "null",
      "GetDemandGenerationList"
    );
 
    const list = Array.isArray(data)
      ? data
      : data?.result || [];
 
    // Latest Demand Generation ID first
     
    const sortedList = [...list].sort(
      (a, b) => Number(b.DgRowID || 0) - Number(a.DgRowID || 0)
    );
 
    setTechnicalInwards(sortedList);
    setCurrentPage(1);
  } catch (error) {
    console.error(
      "Error fetching demand generation list:",
      error
    );
    setTechnicalInwards([]);
  }
   finally {
    setListLoading(false);
  }
};
 
  const getDemandGenerationListForbillPDF = async (demandId = null) => {
    try {
      const idToUse = demandId || selectedDemandID;
      let data1 = await GetBudgetHeadInfo(
        "null",
        "GetDemandGenerationListForbillPDF",
        idToUse,
      );
      console.log("dataForbillPDF ------------", data1);
      setFilteredBills2(data1);
      return data1;
    } catch (err) {
      console.log("Error in getDemandGenerationListForbillPDF:", err);
      return [];
    }
  };
  useEffect(() => {
    getDemandGenerationList();
  }, []);

  let inwardList = [];
  if (technicalInwards.length > 0) {
    inwardList = technicalInwards;
  }
  // above usefect comment for sattus filter 16-09
 useEffect(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
 
    const filtered = technicalInwards.filter((bill) => {
        const matchesSearch = Object.values(bill).some((val) =>
            (val || "").toString().toLowerCase().includes(lowerSearchTerm)
        );
 
                const billStatus = String(bill.Status || "").trim().toLowerCase(); //12-10 

       // 12-10
        const matchesStatus =
  statusFilter === "All" ||
  (statusFilter === "Pending"
    ? billStatus === "pending" || billStatus === "false"
    : billStatus === statusFilter.trim().toLowerCase());
    // ----
        return matchesSearch && matchesStatus;
    });
 
    setFilteredBills(filtered);
    setCurrentPage(1);
}, [searchTerm, statusFilter, technicalInwards]);
  const handleCheckboxChange = (id) => {
    setSelectedBills((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((billId) => billId !== id)
        : [...prevSelected, id],
    );
  };

  console.log("Slected id form table :: ", selectedBills);
  console.log("Filtered data id form table :: ", filteredBills);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedBills(currentBills.map((bill) => bill.ProposalID));
    } else {
      setSelectedBills([]);
    }
  };

  const settingshowspecific3 = async (DemandID) => {
    try {
      let res = await GetVendorBillsAndDeduction(DemandID);
      console.log("GetVendorBillsAndDeduction", res);

      setfetchSpecficDemandDeductionDetail(res);

      setSelectedDemandID(DemandID);

      const billsForPDF = await getDemandGenerationListForbillPDF(DemandID);
      setShowSpecific(3);

      const filtered = Array.isArray(billsForPDF)
        ? billsForPDF.filter((val) => val.DemandGenerationID == DemandID)
        : [];

      const billData = filtered[0] || {};
      const vendorData = Array.isArray(res)
        ? res.find((item) => item.DemandGenerationID == DemandID)
        : res;
      setselectedBillData({
        ...billData,
        PhysicalProgress: vendorData?.PhysicalProgress,
      });
    } catch (err) {
      console.log(err);
    }
  };

  const BackFunction = () => {
    setfetchSpecficDemandDeductionDetail([]);
    setselectedBillData({});
    setSelectedDemandID(null);
    setShowSpecific(0);
  };

  const exportBillSlipPDF = async () => {
    if (!billSlipRef.current) {
      alert("Bill slip not found");
      return;
    }

    setExportingBillSlipPDF(true);

    try {
      const canvas = await html2canvas(billSlipRef.current, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
      });

      const pdf = new jsPDF("p", "mm", "a4");

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const margin = 5;

      const maxImgWidth = pageWidth - margin * 2;
      const maxImgHeight = pageHeight - margin * 2;

      const widthRatio = maxImgWidth / canvas.width;
      const heightRatio = maxImgHeight / canvas.height;

      const ratio = Math.min(widthRatio, heightRatio);

      const imgWidth = canvas.width * ratio;
      const imgHeight = canvas.height * ratio;

      pdf.addImage(
        canvas.toDataURL("image/png"),
        "PNG",
        (pageWidth - imgWidth) / 2,
        margin,
        imgWidth,
        imgHeight,
      );

      const transactionNo = selectedBillData?.TransactionNo || selectedDemandID;

      pdf.save(`Bill_Slip_${transactionNo || "MMGSY"}.pdf`);
    } catch (error) {
      console.error("Bill slip PDF export error:", error);

      alert("Failed to export bill slip PDF.");
    } finally {
      setExportingBillSlipPDF(false);
    }
  };

  const headerStyle = {
    padding: "12px 16px",
    whiteSpace: "nowrap",
    borderRight: "1px solid #e0e0e0",
    textTransform: "capitalize",
  };
  const commonWidth = `${100 / 7}%`; // whatever the current width of Department Auditor looks like

  const headerStyle1 = {
    width: commonWidth,
    padding: "12px 16px",
    whiteSpace: "nowrap",
    borderRight: "1px solid #e0e0e0",
    textTransform: "capitalize",
  };

  const cellStyle = {
    width: commonWidth, // 100% / 7 columns
    padding: "8px",
    textAlign: "center",
    //   whiteSpace: 'nowrap'
  };

  const exportTableByClassToExcel = async (
    bills,
    filename = "Bills_Outward.xlsx",
  ) => {
    if (!bills || bills.length === 0) {
      alert("No data available");
      return;
    }
    setloading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    try {
      const getStatus = (val) =>
        val === "true" ? "✓" : val === "false" ? "✕" : "-";

      const excelData = bills.map((proposal, index) => ({
        "Sr.No.": index + 1,
        "Bill ID": proposal.DemandGenerationID,
        "Bill Number": proposal.RABillNumber,
        "Work Name": proposal.ProjectID,
        // "Agreement Number": proposal.AgreementUID,
        Block: proposal.Block,
        "Vendor Name": proposal.ContractorName,
        "Upload Bill Copy": proposal.UploadBillCopy || "No File",
        "Bill Copy": proposal.BillCopy || "No File",
        Remark: proposal.Remark || "",
        "Bill Amount": proposal.BillAmount || 0,
        "Net Payable Amount": proposal.NetPayableAmount || 0,
        "Deduction Amount": proposal.DeductionAmount || 0,
        Date: proposal.Date ? new Date(proposal.Date).toLocaleString() : "",
        "Department Auditor": getStatus(proposal.Approvance1),
        "Department HOD(EE)": getStatus(proposal.Approvance2),
        "FD Auditor": getStatus(proposal.Approvance3),
        "FD AAO": getStatus(proposal.Approvance4),
        "FD AO": getStatus(proposal.Approvance5),
        "Deputy CAFO": getStatus(proposal.Approvance6),
        CAFO: getStatus(proposal.Approvance7),
        BudgetHead: proposal.BudgetHead,
        PhysicalProgress: proposal.PhysicalProgress,
      }));

      /* 🔢 TOTAL ROW */
      const totalRow = {
        "Sr.No.": "Total",
        "Bill ID": "",
        "Bill Number": "",
        "Work Name": "",
        "Agreement Number": "",
        Block: "",
        "Vendor Name": "",
        "Upload Bill Copy": "",
        "Bill Copy": "",
        Remark: "",
        "Head Name": "",
        "Physical Progress": "",
        "Bill Amount": bills.reduce(
          (sum, b) => sum + Number(b.BillAmount || 0),
          0,
        ),
        "Net Payable Amount": bills.reduce(
          (sum, b) => sum + Number(b.NetPayableAmount || 0),
          0,
        ),
        "Deduction Amount": bills.reduce(
          (sum, b) => sum + Number(b.DeductionAmount || 0),
          0,
        ),
        Date: "",
        "Department Auditor": "",
        "Department HOD(EE)": "",
        "FD Auditor": "",
        "FD AAO": "",
        "FD AO": "",
        "Deputy CAFO": "",
        CAFO: "",
      };

      excelData.push(totalRow);

      const worksheet = XLSX.utils.json_to_sheet(excelData);

      /* Column width */
      worksheet["!cols"] = Object.keys(excelData[0]).map(() => ({
        wch: 22,
      }));

      /* Freeze header */
      worksheet["!freeze"] = { xSplit: 0, ySplit: 1 };

      /* Filter */
      worksheet["!autofilter"] = {
        ref: XLSX.utils.encode_range({
          s: { r: 0, c: 0 },
          e: {
            r: excelData.length,
            c: Object.keys(excelData[0]).length - 1,
          },
        }),
      };

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Bills");
      XLSX.writeFile(workbook, filename);
    } catch (error) {
      console.error("Excel Export Error:", error);
    } finally {
      setloading(false); // ✅ ALWAYS stop loader
    }
  };

  const downloadTableOnlyAsPDF = async (
    tableClass,
    filename,
    title,
    chunkSize = 500, // 🔥 300–500 recommended
  ) => {
    const originalTable = document.querySelector(`.${tableClass}`);
    if (!originalTable) {
      setExportingPDF(false);
      return;
    }

    setloading(true);
    setExportingPDF(true);

    // Allow loader to render first
    await new Promise((resolve) => setTimeout(resolve, 600));

    try {
      const originalRows = originalTable.querySelectorAll("tbody tr");
      const totalRows = originalRows.length;

      if (!totalRows) {
        setloading(false);
        setExportingPDF(false);
        return;
      }

      for (let start = 0; start < totalRows; start += chunkSize) {
        const end = Math.min(start + chunkSize, totalRows);

        // 🔥 Clone table cleanly
        const tableClone = originalTable.cloneNode(true);
        const rows = tableClone.querySelectorAll("tbody tr");

        // Remove rows outside current chunk
        rows.forEach((row, index) => {
          if (index < start || index >= end) {
            row.remove();
          }
        });

        // Hide cloned table from view
        tableClone.style.position = "absolute";
        tableClone.style.left = "-9999px";
        tableClone.style.top = "0";
        document.body.appendChild(tableClone);

        const pdf = new jsPDF("p", "mm", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const topMargin = 25;
        const sideMargin = 10;
        const bottomMargin = 15;

        pdf.setFontSize(16);
        pdf.setFont("helvetica", "bold");
        pdf.text(`${title} (${start + 1} - ${end})`, pageWidth / 2, 15, {
          align: "center",
        });

        const canvas = await html2canvas(tableClone, {
          scale: 1,
          useCORS: true,
          backgroundColor: "#2C78DB",
        });

        const imgWidth = pageWidth - sideMargin * 2;
        const pxToMm = imgWidth / canvas.width;

        const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
        const usablePageHeightPx = usablePageHeightMm / pxToMm;

        let renderedHeight = 0;
        let pageNumber = 0;

        while (renderedHeight < canvas.height) {
          const sliceHeight = Math.min(
            usablePageHeightPx,
            canvas.height - renderedHeight,
          );

          const pageCanvas = document.createElement("canvas");
          const context = pageCanvas.getContext("2d");

          pageCanvas.width = canvas.width;
          pageCanvas.height = sliceHeight;

          context.drawImage(
            canvas,
            0,
            renderedHeight,
            canvas.width,
            sliceHeight,
            0,
            0,
            canvas.width,
            sliceHeight,
          );

          const imgData = pageCanvas.toDataURL("image/jpeg", 0.85);

          if (pageNumber > 0) pdf.addPage();

          pdf.addImage(
            imgData,
            "JPEG",
            sideMargin,
            topMargin,
            imgWidth,
            sliceHeight * pxToMm,
          );

          renderedHeight += sliceHeight;
          pageNumber++;
        }

        pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);

        document.body.removeChild(tableClone);

        // Small delay prevents UI freezing
        await new Promise((resolve) => setTimeout(resolve, 300));
      }
    } catch (error) {
      console.error("PDF Export Error:", error);
    } finally {
      setExportingPDF(false);
      setloading(false);
    }
  };
  const row = fetchSpecificDemandDeductionDetail[0];
  console.log(
    "fetch data for signature-->",
    fetchSpecificDemandDeductionDetail,
  );
  const signatureData = [];
  signatureData.push({
    FullName: row?.CreatedByName || "",
    designation: "New Agency Maker",
    label: "Created Date",
    date: row?.UploadedOn ? row.UploadedOn.split("T")[0] : "-",
  });

  if (row?.Approval1 === "true") {
    signatureData.push({
      FullName: row?.Approval1ByName || "",
      designation: "New Agency Checker",
      label: "Approved Date",
      date: row?.Approval1Date ? row.Approval1Date.split("T")[0] : "-",
    });
  }

  if (row?.Approval2 === "true") {
    signatureData.push({
      FullName: row?.Approval2ByName || "",
      designation: "Agency Maker",
      label: "Approved Date",
      date: row?.Approval2Date ? row.Approval2Date.split("T")[0] : "-",
    });
  }

  if (row?.Approval3 === "true") {
    signatureData.push({
      FullName: row?.Approval3ByName || "",
      designation: "Agency Checker",
      label: "Approved Date",
      date: row?.Approval3Date ? row.Approval3Date.split("T")[0] : "-",
    });
  }

  if (row?.Approval4 === "true") {
    signatureData.push({
      FullName: row?.Approval4ByName || "",
      designation: "State Maker",
      label: "Approved Date",
      date: row?.Approval4Date ? row?.Approval4Date.split("T")[0] : "-",
    });
  }

  if (row?.Approval5 === "true") {
    signatureData.push({
      FullName: row?.Approval5ByName || "",
      designation: "State Checker",
      label: "Approved Date",
      date: row?.Approval5Date ? row?.Approval5Date.split("T")[0] : "-",
    });
  }

  // const formatDBDate = (dateValue) => {
  //   if (!dateValue) return "-";

  //   // If MySQL returns: 2026-08-10 13:49:23
  //   if (typeof dateValue === "string") {
  //     const match = dateValue.match(
  //       /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})/,
  //     );

  //     if (match) {
  //       const [, year, month, day, hour, minute, second] = match;

  //       return `${day}-${month}-${year} ${hour}:${minute}:${second}`;
  //     }
  //   }

  //   // Fallback if backend returns a JS Date / ISO date
  //   const date = new Date(dateValue);

  //   if (isNaN(date.getTime())) return "-";

  //   const day = String(date.getDate()).padStart(2, "0");
  //   const month = String(date.getMonth() + 1).padStart(2, "0");
  //   const year = date.getFullYear();

  //   const hour = String(date.getHours()).padStart(2, "0");
  //   const minute = String(date.getMinutes()).padStart(2, "0");
  //   const second = String(date.getSeconds()).padStart(2, "0");

  //   return `${day}-${month}-${year} ${hour}:${minute}:${second}`;
  // };

   const formatDBDate = (dateValue) => {
  if (!dateValue) return "-";

  const value = String(dateValue).trim();

  // Supports YYYY-MM-DD or YYYY-MM-DD HH:mm:ss
  const match = value.match(/^(\d{4})-(\d{2})-(\d{2})/);

  if (match) {
    const [, year, month, day] = match;
    return `${day}-${month}-${year}`;
  }

  const date = new Date(value);

  if (isNaN(date.getTime())) return "-";

  return `${String(date.getDate()).padStart(2, "0")}-${String(
    date.getMonth() + 1
  ).padStart(2, "0")}-${date.getFullYear()}`;
};
// ----
  const getPageNumbers = () => {
    const maxVisiblePages = 5;

    // Total pages 5
    if (totalPages <= maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    // Page 1, 2, 3 par
    // 1 2 3 4 5 ... Last
    if (currentPage <= 3) {
      return [1, 2, 3, 4, 5, "...", totalPages];
    }

    // Last pages
    // ... 16 17 18 19 20
    if (currentPage >= totalPages - 2) {
      return [
        "...",
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      ];
    }

    // Middle pages
    // ... 4 5 6 7 8 ... 20
    return [
      "...",
      currentPage - 2,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      currentPage + 2,
      "...",
      totalPages,
    ];
  };



const [editLoading, setEditLoading] = useState(false);

const handleEditDemand = async (item) => {
  setEditLoading(true);
  try {
    const deductionRes = await GetVendorBillsAndDeduction(item.DemandGenerationID);
    console.log("🔥 DEDUCTION API RESPONSE:", deductionRes);
    const billsForPDF = await getDemandGenerationListForbillPDF(item.DemandGenerationID);

    const filtered = Array.isArray(billsForPDF)
      ? billsForPDF.filter((val) => val.DemandGenerationID == item.DemandGenerationID)
      : [];
    const fullBillData = filtered[0] || {};

    const vendorRows = Array.isArray(deductionRes) ? deductionRes : [];
    const vendorData = vendorRows.find(
      (v) => v.DemandGenerationID == item.DemandGenerationID
    );

    // Dedupe by id (backend JOIN currently returns one row per approver)
    const seenIds = new Set();
    const uniqueDeductionRows = vendorRows.filter((val) => {
      if (val.TypeOfAmount === "Total Amount Payable") return false; // that's the vendor payable row, not a deduction
      if (seenIds.has(val.id)) return false;
      seenIds.add(val.id);
      return true;
    });

    const billAmount = Number(fullBillData.BillAmount || item.BillAmount || 0);

  

// 24-09 deduction amount fetch
 const mappedDeductions = uniqueDeductionRows.map((val) => {
  const deductionAmount = Number(val.TotalAmount) || 0;

  return {
    ProjectID: fullBillData.ProjectID || item.ProjectID,
    HeadID: fullBillData.BudgetID || item.BudgetID,
    WorkUniqueID: val.WorkUniqueID,

    DeductionAmount: deductionAmount,

    DeductionPercent:
      billAmount > 0
        ? Number(((deductionAmount / billAmount) * 100).toFixed(2))
        : 0,

    DeductionName: val.TypeOfAmount,
    DeductionID: val.id,
  };
});

console.log("🔥 MAPPED DEDUCTIONS:", mappedDeductions);

const completeItem = {
  ...item,
  ...fullBillData,
  DeductionList: mappedDeductions,
  PhysicalProgress: vendorData?.PhysicalProgress,
};

// ⭐ THIS WAS MISSING
setDeductionList(mappedDeductions);

setEditBillData(completeItem);
setShowEditForm(true);

  } catch (err) {
    console.error("Error fetching demand details for edit:", err);
    alert("Failed to load bill details for editing.");
  } finally {
    setEditLoading(false);
  }
};




const handleApproveDemand = async (item) => {
  const shouldProceed = window.confirm("Are you sure you want to approve this Demand?");
  if (!shouldProceed) return;

  try {
    const response = await ApproveBills([item.DemandGenerationID], "Approved", "");
    if (response?.message) alert(response.message);
    else if (response?.error) alert(response.error);
    getDemandGenerationList(); // refresh list
  } catch (err) {
    console.error("Error approving Demand:", err);
    alert("An error occurred while approving.");
  }
};


// 09-10 for sepraate agnecy 


// const APPROVAL_LEVELS = [
//   { key: "Approval",  nameKey: "CreatedByUsername",   agencyKey: "ChildAgencyName",  role: "New Agency Maker" },
//   { key: "Approval1", nameKey: "Approval1ByUsername", agencyKey: "ChildAgencyName",  role: "New Agency Checker" },
//   { key: "Approval2", nameKey: "Approval2ByUsername", agencyKey: "ParentAgencyName", role: "Agency Maker" },
//   { key: "Approval3", nameKey: "Approval3ByUsername", agencyKey: "ParentAgencyName", role: "Agency Checker" },
//   { key: "Approval4", nameKey: "Approval4ByUsername", agencyKey: null,               role: "State Maker",   fixedLabel: "State" },
//   { key: "Approval5", nameKey: "Approval5ByUsername", agencyKey: null,               role: "State Checker", fixedLabel: "State" },
// ];
// 19-10
const APPROVAL_LEVELS = [
  {
    key: "Approval",
    nameKey: "CreatedByUsername",
    fullNameKey: "CreatedByName",
    role: "New Agency Maker",
  },
  {
    key: "Approval1",
    nameKey: "Approval1ByUsername",
    fullNameKey: "Approval1ByName",
    role: "New Agency Checker",
  },
  {
    key: "Approval2",
    nameKey: "Approval2ByUsername",
    fullNameKey: "Approval2ByName",
    role: "Agency Maker",
  },
  {
    key: "Approval3",
    nameKey: "Approval3ByUsername",
    fullNameKey: "Approval3ByName",
    role: "Agency Checker",
  },
  {
    key: "Approval4",
    nameKey: "Approval4ByUsername",
    fullNameKey: "Approval4ByName",
    role: "State Maker",
  },
  {
    key: "Approval5",
    nameKey: "Approval5ByUsername",
    fullNameKey: "Approval5ByName",
    role: "State Checker",
  },
];
const isTrue = (v) =>
  v === true || String(v).toLowerCase() === "true" || String(v) === "1";

const isApprovedAt = (item, level) => {
  const status = String(item.ApproveStatus || "").toLowerCase();
  if (status === "approved all") return true;
  return isTrue(item[level.key]);
};


const getLevelLabel = (level) => {
  if (level.key === "Approval") {
    return technicalInwards?.[0]?.ChildAgencyName || "Agency";
  }

  if (level.key === "Approval1") {
    return technicalInwards?.[0]?.ChildAgencyName || "Agency";
  }

  if (level.key === "Approval2") {
    return technicalInwards?.[0]?.ParentAgencyName || "Agency";
  }

  if (level.key === "Approval3") {
    return technicalInwards?.[0]?.ParentAgencyName || "Agency";
  }

  if (level.key === "Approval4") {
    return technicalInwards?.[0]?.Approval4ByUsername || "State Maker";
  }

  if (level.key === "Approval5") {
    return technicalInwards?.[0]?.Approval5ByUsername || "State Checker";
  }

  return level.role;
};


// const renderApprovalIcon = (item, level) => {
//   const approved = isApprovedAt(item, level);

//   if (!approved) {
//     return (
//       <span title="Not approved" style={{ color: "#dc3545", fontSize: "20px", fontWeight: "bold" }}>
//         ✕
//       </span>
//     );
//   }

//   return (
//     <span
//       title={`${level.role}: ${item[level.nameKey] || "-"}`}
//       style={{ color: "#28a745", fontSize: "20px", fontWeight: "bold" }}
//     >
//       ✓
//     </span>
//   );
// };
const renderApprovalIcon = (item, level) => {
  const approved = isApprovedAt(item, level);

  return approved ? (
    <span
      title={`${level.role}: Approved`}
      style={{
        color: "#28a745",
        fontSize: "22px",
        fontWeight: "bold",
      }}
    >
      ✓
    </span>
  ) : (
    <span
      title={`${level.role}: Not approved`}
      style={{
        color: "#dc3545",
        fontSize: "22px",
        fontWeight: "bold",
      }}
    >
      ✕
    </span>
  );
};


// 28-10

//28/10
const formatSlipDate = (v) => {
  if (!v) return "-";
  const d = new Date(v);
  if (isNaN(d.getTime())) return "-";
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
};
//28/10
const getPrintDate = () => {
  return new Date().toLocaleString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};

const d = selectedBillData || {};
const slipCell = {
  border: "none",
  backgroundColor: "#fff",
  padding: "6px 8px",
  fontSize: "13px",
  textAlign: "left",
  verticalAlign: "middle",
  fontFamily: "'Times New Roman', serif",
  wordBreak: "break-word",
};
const slipLabel = {
  ...slipCell,
  width: "40%",
  fontWeight: 700,
  backgroundColor: "#EAF1FB",
};
const slipRows = [
  ["Bill Created By", d.CreatedByAgencyFullName || "-"],
  ["Project Name", d.ProjectName || "-"],
  ["Agency Name", d.Agency_Name || "-"],
  ["Work Name", d.WorkName || "-"],
  ...(d.BudgetHead ? [["Head Name", d.BudgetHead]] : []),
  ["RA Bill", d.RABillNumber || "-"],
  ...(d.Scheme === "Budget" ? [["CRC", d.CRC || "-"]] : []),
  ["PhysicalProgress", d.PhysicalProgress ?? "-"],
];
// ===== Amount Details =====
const ones = ["","One","Two","Three","Four","Five","Six","Seven","Eight","Nine","Ten","Eleven","Twelve","Thirteen","Fourteen","Fifteen","Sixteen","Seventeen","Eighteen","Nineteen"];
const tensW = ["","","Twenty","Thirty","Forty","Fifty","Sixty","Seventy","Eighty","Ninety"];
const twoDigit = (n) =>
  n < 20 ? ones[n] : tensW[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");

const numberToWords = (value) => {
  const amt = Number(value || 0);
  const rupees = Math.floor(amt);
  const paise = Math.round((amt - rupees) * 100);
  if (rupees === 0 && paise === 0) return "Zero Rupees Only";
  const parts = [
    [Math.floor(rupees / 10000000), "Crore"],
    [Math.floor(rupees / 100000) % 100, "Lakh"],
    [Math.floor(rupees / 1000) % 100, "Thousand"],
    [Math.floor(rupees / 100) % 10, "Hundred"],
  ];
  let words = parts.filter(([n]) => n).map(([n, u]) => `${twoDigit(n)} ${u}`).join(" ");
  const last = rupees % 100;
  if (last) words += (words ? " " : "") + twoDigit(last);
  return `${words} Rupees and ${paise ? twoDigit(paise) : "Zero"} Paise Only`;
};

const seenIds = new Set();
const uniqueDetailRows = (Array.isArray(fetchSpecificDemandDeductionDetail)
  ? fetchSpecificDemandDeductionDetail
  : []
).filter((v) => {
  if (v.id == null) return true;
  if (seenIds.has(v.id)) return false;
  seenIds.add(v.id);
  return true;
});
const amountRows = [
  ...uniqueDetailRows
    .filter((v) => v.TypeOfAmount == "Total Amount Payable")
    .map((v) => ({
      type: "Net Pay",
      payee: v.Vendor_Company_Name,
      acc: v.Bank_Account_Number,
      ifsc: v.Bank_IFSC_Code,
      amount: v.TotalAmount,
    })),
  ...uniqueDetailRows
    .filter((v) => v.TypeOfAmount != "Total Amount Payable")
    .map((v) => ({
      type: v.TypeOfAmount,
      payee: v.PayeeName || v.Branch_Name,  
      acc: v.Bank_Account_Number,
      ifsc: v.Bank_IFSC_Code,
      amount: v.TotalAmount,
    })),
];
const amtHead = {
  backgroundColor: "#1190CA",
  color: "#fff",
  fontWeight: 700,
  fontSize: "12px",
  padding: "6px 4px",
  textAlign: "center",
  fontFamily: "'Times New Roman', serif",
};
const amtCell = (i) => ({
  backgroundColor: i % 2 === 0 ? "#E5F4FB" : "#CFE4F1",
  fontSize: "12px",
  padding: "6px 4px",
  textAlign: "center",
  verticalAlign: "middle",
  fontFamily: "'Times New Roman', serif",
  wordBreak: "break-all",
});
const amtTotal = {
  backgroundColor: "#fff",
  fontSize: "13px",
  fontWeight: 700,
  padding: "8px 6px",
  textAlign: "center",
  fontFamily: "'Times New Roman', serif",
};
const seenBen = new Set();
const beneficiaryRows = uniqueDetailRows
  .filter((v) => v.TypeOfAmount == "Total Amount Payable")
  .filter((v) => {
    const k = `${v.Vendor_Company_Name}|${v.Bank_Account_Number}|${v.Bank_IFSC_Code}`;
    if (seenBen.has(k)) return false;
    seenBen.add(k);
    return true;
  });
const summaryRows = [
  ["Bill Amount", d.BillAmount ?? "-"],
  ["Bill Amount in Word", numberToWords(d.BillAmount), true],
  ["Net Payable", d.NetPayableAmount ?? "-"],
  ["Deduction", d.DeductionAmount ?? "-"],
];
return (
    <>

  {/* //28/10 */}
   <style>{`
  .dg-spinner {
    width: 32px;
    height: 32px;
    border: 3px solid #d7e3fb;
    border-top-color: #2ea4e7;
    border-radius: 50%;
    animation: dg-spin 0.8s linear infinite;
  }
  @keyframes dg-spin {
    to { transform: rotate(360deg); }
  }

  /* ===== Bill Slip: sab tables ===== */
  .bs-wrap > table {
    width: 100% !important;
    margin: 0 0 20px 0 !important;
    border: 0 !important;
    border-radius: 0 !important;
    border-collapse: separate !important;
    border-spacing: 1px !important;
    background-color: #000 !important;
  }
  .bs-wrap > table tr {
    border: 0 !important;
  }
  .bs-wrap > table td,
  .bs-wrap > table th {
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    padding: 6px 8px !important;
    font-family: 'Times New Roman', serif !important;
    font-size: 13px;
    vertical-align: middle !important;
    word-break: break-word;
    background-color: #fff;
  }

  /* ===== Table 1: Bill Slip for LRS ===== */
  .bs-wrap > table:nth-of-type(1) tr:first-child td {
    text-align: center !important;
    font-weight: 700 !important;
  }
  .bs-wrap > table:nth-of-type(1) td:first-child:not([colspan]) {
    width: 40% !important;
    font-weight: 700 !important;
  }
  .bs-wrap > table:nth-of-type(1) td:last-child:not([colspan]) {
    width: 60% !important;
  }

  /* ===== Table 2: Total Bill Amount / Net Payable / Deduction ===== */
  .bs-wrap > table:nth-of-type(2) tr:first-child td {
    background-color: #EAF1FB;
    font-weight: 700 !important;
  }

  /* ===== Table 3: Vendor Details ===== */
  .bs-wrap > table:nth-of-type(3) tr:first-child td {
    background-color: #2C78DB !important;
    color: #fff !important;
    text-align: center !important;
    font-weight: 700 !important;
    font-size: 14px !important;
    padding: 10px !important;
  }
  .bs-wrap > table:nth-of-type(3) tr:nth-child(2) td {
    background-color: #1190CA !important;
    color: #fff !important;
    text-align: center !important;
    font-weight: 700 !important;
    font-size: 12px !important;
  }
  .bs-wrap > table:nth-of-type(3) tr:nth-child(n+3) td {
    text-align: center;
    font-size: 12px !important;
  }
  .bs-wrap > table:nth-of-type(3) tr:last-child td {
    background-color: #fff !important;
    font-weight: 700 !important;
  }
  .bs-wrap > table:nth-of-type(3) tr:last-child td:first-child {
    text-align: right !important;
  }

  /* ===== Table 4: Deduction Amount Details ===== */
  .bs-wrap > table:nth-of-type(4) thead tr:first-child td {
    background-color: #2C78DB !important;
    color: #fff !important;
    text-align: center !important;
    font-weight: 700 !important;
    font-size: 14px !important;
    padding: 10px !important;
  }
  .bs-wrap > table:nth-of-type(4) thead th {
    background-color: #1190CA !important;
    color: #fff !important;
    text-align: center !important;
    font-size: 12px !important;
    font-weight: 700 !important;
  }
  .bs-wrap > table:nth-of-type(4) tbody td {
    text-align: center;
    font-size: 12px !important;
  }
  .bs-wrap > table:nth-of-type(4) tbody tr:nth-child(odd) td {
    background-color: #E5F4FB !important;
  }
  .bs-wrap > table:nth-of-type(4) tbody tr:nth-child(even) td {
    background-color: #CFE4F1 !important;
  }
  .bs-wrap > table:nth-of-type(4) tbody tr:last-child td {
    background-color: #fff !important;
    font-weight: 700 !important;
  }

  /* ===== Signature boxes (5th table) ===== */
  .bs-wrap > table.bs-sign td {
    background-color: #EAF1FB !important;
  }
  .bs-wrap > table.bs-sign td:empty {
    background-color: #fff !important;
    height: 95px !important;
  }
    
/* ===== Demand Generation Table UI ===== */

.dg-table-card {
  background: #ffffff;
  border-radius: 14px;
  padding: 22px 15px 18px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.10);
  border: 1px solid #edf0f5;
  width: 100%;
  box-sizing: border-box;
}

.dg-table-scroll {
  width: 100%;
  overflow: auto;
  position: relative;
  border: 1px solid #d5deed;
  border-radius: 8px;
  
}

.dg-table-scroll .demand-generation-table {
  width: 100%;
  min-width: 1400px;
  border-collapse: separate !important;
  border-spacing: 0 !important;
  table-layout: auto;
  background: #fff;
  margin: 0;
}

/* Blue header */
.demand-generation-table thead th {
  background: #2f7de1 !important;
  color: #ffffff !important;
  border-right: 1px solid #b8d2f4 !important;
  border-bottom: 1px solid #b8d2f4 !important;
  padding: 10px 9px !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  text-align: center !important;
  vertical-align: middle !important;
  white-space: nowrap;
}

/* Alternate light-blue rows */
.demand-generation-table tbody tr td {
  padding: 12px 9px !important;
  border-right: 1px solid white !important;
  border-bottom: 1px solid white !important;
  font-size: 12px !important;
  color: #102d4d;
  text-align: center;
  vertical-align: middle;
  line-height: 1.4;
  background-color: #e5f2fc !important;
}

.demand-generation-table tbody:nth-of-type(even) tr td {
  background-color: #cfe5f3 !important;
}

/* Keep IDs highlighted */
.demand-generation-table tbody tr td:nth-child(2) {
  color: #327dc5 !important;
  font-weight: 600;
}

/* Scrollbar */
.dg-table-scroll::-webkit-scrollbar {
  width: 8px;
  height: 9px;
}

.dg-table-scroll::-webkit-scrollbar-thumb {
  background: #929292;
  border-radius: 8px;
}

.dg-table-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Responsive */
@media (max-width: 768px) {
  .dg-table-card {
    padding: 12px 8px;
  }

  .dg-table-scroll {
    height: 400px;
  }
}

`}</style>


      {!showEditForm ? (
       <div
         style={{
           width: "100%",
           maxHeight: "90vh",
           background: "white",
           padding: "18px 20px 25px",
           boxSizing: "border-box",
           fontFamily: "Inter, sans-serif",
           overflow: "hidden",
           // border:"1px solid red"
         }}
       >
         {/* //29/10 */}
         <div
         style={{
           width: "100%",
           background: "#EEF1F6",
           borderRadius: "12px",
           padding: "18px 15px",
           boxSizing: "border-box",
           boxShadow: "0 3px 10px rgba(0, 0, 0, 0.10)",
           border: "1px solid #E1E6EF",
         }}
       >
         {/* //30/10 */}
         {showspecific === 0 && (
         <div
           style={{
             display: "flex",
             justifyContent: "space-between",
             alignItems: "center",
             marginBottom: "10px",
             padding: "0 20px",
             width: "100%",
           }}
         >
           <h5
             style={{
               fontWeight: "bold",
               color: "black",
               display: "flex",
               alignItems: "center",
             }}
           >
            <img
       src="/Bill-Approval-List-32.png"
       alt="img"
      style={{height:"28px", width:"28px", marginRight:"10px"}}
     />
             Demand Generation List
           </h5>
   
            <div style={{display:"flex",justifyContent:"center",gap:"10px",}}>
             {/* //26/10 */}
             {showspecific === 0 && (
             <>
           <div
             style={{
               display: "flex",
               alignItems: "center",
               // backgroundColor: "aliceblue",
               border: "1px solid #ccc",
               borderRadius: "5px",
               padding: "5px 10px",
               //29/10
               backgroundColor:"white",
               width: "250px",
             }}
           >
             <img
               src={"/Search-32.png"}
               alt="Search Icon"
               style={{ width: 20, height: 20, marginRight: "8px" }}
             />
             <input
               type="text"
               placeholder="Search Demand Generation..."
               value={searchTerm}
               onChange={(e) => setSearchTerm(e.target.value)}
               style={{
                 border: "none",
                 outline: "none",
                 background: "transparent",
                 width: "100%",
                 fontSize: "14px",
               }}
             />
           </div>
           <select
       value={statusFilter}
       onChange={(e) => setStatusFilter(e.target.value)}
       style={{
           width: "140px",
           height: "36px",
           marginLeft: "10px",
           border: "1px solid #d5dce5",
           borderRadius: "8px",
           padding: "0 10px",
           fontSize: "12px",
           outline: "none",
           background: "#fff",
           cursor: "pointer"
       }}
   >
       <option value="All">All Status</option>
       <option value="Pending">Pending</option>
       <option value="SendBack">SendBack</option>
       <option value="Generated">Generated</option>
       <option value="Rejected">Rejected</option>
           </select>
             {/* //26/10 */}
              </>
             )}
   </div>
         </div>
         )}
   
         {showspecific === 0 && (
           //28/10
           <div
             className="dg-table-card"
       style={{
         display: "block",
         maxHeight: "85vh",
         overflow: "hidden",
       }}
           >
             <div
               style={{
                 width: "100%",
                 border: "1px solid #d7deeb",
                 borderRadius: "10px",
                 background: "#ffffff",
                 boxSizing: "border-box",
                 overflow: "hidden",
               }}
             >
               <div
                 style={{
                   width: "100%",
                   // overflowX: "auto",
                   // overflowY: "hidden",
                      overflow: "hidden",
                 }}
               >
                 {/* 13-10 */}
                 {/* //28/10 */}
                  <div className="dg-table-scroll">
                <table className="demand-generation-table">
                 
   <thead>
     {/* FIRST HEADER ROW */}
     <tr
       style={{
         backgroundColor: "#E5EBFA",
         color: "#222",
         height: "38px",
         fontSize: "12px",
         fontWeight: "600",
         textAlign: "center",
         whiteSpace: "nowrap",
       }}
     >
       {[
         "Sr.No",
         "Bill UID",
         "RA Bill Number",
         "Contractor Name",
         "Bill Amount",
         "Deduction Amount",
         "Payable Amount",
         "Remark",
         "Uploaded File",
         "Date",
         "Approve Status",
       ].map((heading) => (
         <th
           key={heading}
           rowSpan={2}
           style={{
             padding: "7px 8px",
             background: "#E5EBFA",
             color: "#222",
             borderRight: "1px solid #d4dced",
             borderBottom: "1px solid #d4dced",
             fontSize: "12px",
             fontWeight: "700",
             textAlign: "center",
             whiteSpace: "nowrap",
           }}
         >
           {heading}
         </th>
       ))}
   
       {/* GROUP HEADING (top row) */}
       <th
         colSpan={APPROVAL_LEVELS.length}
         style={{
           padding: "7px 8px",
           background: "#E5EBFA",
           borderRight: "1px solid #d4dced",
           borderBottom: "1px solid #d4dced",
           fontSize: "12px",
           fontWeight: "700",
           textAlign: "center",
           whiteSpace: "nowrap",
         }}
       >
         Approve By
       </th>
   
       {["Status", "View MAS Slip"].map((heading) => (
         <th
           key={heading}
           rowSpan={2}
           style={{
             padding: "7px 8px",
             background: "#E5EBFA",
             borderRight: "1px solid #d4dced",
             borderBottom: "1px solid #d4dced",
             fontSize: "12px",
             fontWeight: "700",
             textAlign: "center",
             whiteSpace: "nowrap",
           }}
         >
           {heading}
         </th>
       ))}
   
       {isMaker && (
         <>
           <th rowSpan={2} style={headerStyle}>Action</th>
           <th rowSpan={2} style={headerStyle}>Approve</th>
         </>
       )}
     </tr>
   
     {/* SECOND HEADER ROW: names only */}
     <tr
       style={{
         backgroundColor: "#E5EBFA",
         color: "#222",
         fontSize: "11px",
         fontWeight: "700",
         textAlign: "center",
         whiteSpace: "nowrap",
       }}
     >
       {/* {APPROVAL_LEVELS.map((l) => (
         <th
           key={l.key}
           title={l.role}
           style={{
             padding: "7px 10px",
             background: "#E5EBFA",
             borderRight: "1px solid #d4dced",
             borderBottom: "1px solid #d4dced",
             fontSize: "11px",
             fontWeight: "700",
             textAlign: "center",
             whiteSpace: "nowrap",
           }}
         >
           {l.role}
         </th>
       ))} */}
      {APPROVAL_LEVELS.map((level) => {
       const firstItem = technicalInwards?.[0] || {};
   
       const headerName =
         firstItem[level.fullNameKey] ||
         firstItem[level.nameKey] ||
         level.role;
   
       return (
         <th
           key={level.key}
           title={headerName}
           style={{
             minWidth: "135px",
             padding: "12px 10px",
             background: "#E5EBFA",
             borderRight: "1px solid #d4dced",
             borderBottom: "1px solid #d4dced",
             fontSize: "11px",
             fontWeight: "700",
             textAlign: "center",
             whiteSpace: "normal",
             lineHeight: "1.4",
             verticalAlign: "middle",
           }}
         >
           {headerName}
         </th>
       );
     })}
     </tr>
   </thead>
   
                   {currentBills?.map((item, index) => (
                     <tbody key={index}>
                       <tr
                         style={{
                           fontSize: "13px",
                           fontWeight: "500",
                           textAlign: "center",
                           whiteSpace: "nowrap",
                           backgroundColor: index % 2 === 0 ? "white" : "#f4f7fe",
                         }}
                       >
                         <td style={{ padding: "10px" }}>
                           {indexOfFirstBill + index + 1}
                         </td>
                         <td
                           style={{
                             padding: "10px",
                             fontSize: "13px",
                             color: "#37a4f8",
                             fontWeight: "700",
                           }}
                         >
                           {item.DemandGenerationID}{" "}
                         </td>
                         {/* <td style={{ padding: "10px" }}>{item.BudgetHead}</td>
                                           <td style={{ padding: "10px" }}>{item.CRC}</td> */}
                         <td style={{ padding: "10px", fontSize: "13px" }}>
                           {item.RABillNumber}
                         </td>
                         <td style={{ padding: "10px", fontSize: "13px" }}>
                           {item.ContractorName}
                         </td>
                         <td style={{ padding: "10px", fontSize: "13px" }}>
                           {/* {item.BillAmount} */}₹
                           {Number(item.BillAmount || 0).toLocaleString("en-IN")}
                         </td>
                         <td style={{ padding: "10px", fontSize: "13px" }}>
                           {/* {item.DeductionAmount} */}₹
                           {Number(item.DeductionAmount || 0).toLocaleString(
                             "en-IN",
                           )}
                         </td>
                         <td style={{ padding: "10px", fontSize: "13px" }}>
                           {/* {item.NetPayableAmount} */}₹
                           {Number(item.NetPayableAmount || 0).toLocaleString(
                             "en-IN",
                           )}
                         </td>
                         <td style={{ padding: "10px", fontSize: "13px" }}>
                           {item.Remark ? (
                             item.Remark
                           ) : (
                             <span style={{ color: "#d9534f", fontWeight: 700 }}>
                               No Remark
                             </span>
                           )}
                         </td>
                         <td style={{padding: "8px", minWidth: "160px", width: "160px", maxWidth: "160px",whiteSpace: "nowrap", textAlign: "center"}}>
                           {item.UploadBillCopy ? (
                             (() => {
                               // Extract file extension (lowercase)
                               const ext = item.UploadBillCopy.split(".")
                                 .pop()
                                 .toLowerCase();
                               // Choose icon based on file extension
                               // 19-10
                               let icon;
                               if (ext === "pdf") {
     icon = PDF32;
                               }else if (ext === "xls" || ext === "xlsx") {
                                 icon = Excel32; // 🟢 Replace with your actual XLS icon import
                               } else if (ext === "jpg" || ext === "jpeg") {
                                 icon = JPG32; // 🟢 Replace with your actual JPG icon import
                               } else if (ext === "png") {
                                 icon = PNG32; // 🟢 Replace with your actual PNG icon import
                               } else {
                                 icon = UpdateWhite32; // default icon (optional)
                               }
                               return (
                                 <a
                                   href={`${apiurl}/BillCopyDocsImages/${item.UploadBillCopy}`}
                                   target="_blank"
                                   rel="noreferrer"
                                   title={item.UploadBillCopy}
                                   style={{ display: "flex", alignItems: "center",  justifyContent: "center",gap: "5px", width: "100%",overflow: "hidden",textDecoration: "none", color: "#0d6efd", }} >
                                   <img
                                     src={icon}
                                     alt={ext + " icon"}
                                     style={{ width: "20px", height: "20px" }}
                                   />
                                   <span>{item.DemandGenerationID}UploadFile</span>
                                 </a>
                               );
                             })()
                           ) : (
                             <span style={{ color: "#d9534f", fontWeight: 700 }}>
                               No File
                             </span>
                           )}
                         </td>
                         {/* <td style={{ padding: "10px", fontSize: "13px" }}>
                           {formatDBDate(item.Date)}
                         </td> */}
                <td style={{ padding: "10px", fontSize: "13px" }}>
     {formatDBDate(item.DemandGenerationDate || item.Date || item.UploadedOn)}
   </td>
                         <td style={{ padding: "10px", fontSize: "13px" }}>
                           {item.ApproveStatus || "Pending"}
                         </td>
   
   
   {/* 09-10 separete user */}
   
   
   
   {/* {APPROVAL_LEVELS.map((l) => (
     <td key={l.key} style={{ padding: "10px", textAlign: "center" }}>
       {renderApprovalIcon(item, l)}
     </td>
   ))} */}
   {/* 19-10 */}
   {APPROVAL_LEVELS.map((l) => (
     <td
       key={l.key}
       style={{
       minWidth: "135px",
       padding: "12px 10px",
       textAlign: "center",
       verticalAlign: "middle",
       borderRight: "1px solid #d4dced",
     }}
     >
       {renderApprovalIcon(item, l)}
     </td>
   ))}
   
   
                        {/* <td style={{ padding: "10px", fontSize: "13px", fontWeight: "500",  }}>
                       {item.ApproveStatus === "Approved All" ? (
                         <span style={{ display: "flex",alignItems: "center", justifyContent: "center",  gap: "5px", whiteSpace: "nowrap", }} >
                           <img src="/Approved-Amount-32.png"  alt="Approved"  style={{  width: "14px",  height: "14px", }} />
                           Approved All
                         </span>
                       ) : (
                         <span style={{ display: "flex",  alignItems: "center", justifyContent: "center",gap: "5px", whiteSpace: "nowrap",  }} >
                           <img src="/Pending icon 32 Size.png"  alt="Pending"
                             style={{ width: "14px", height: "14px", }}  />  
                                 Pending
                         </span>  )}
                         </td>
     */}
   
                     {/* <td style={{ padding: "10px", fontSize: "13px" }}>{item.Status}</td> */}
                       <td style={{ padding: "10px", fontSize: "13px" }}>
                       <StatusBadge status={String(item.Status ?? "")} />
                     </td>
                     
                         <td style={{ fontSize: "12px", padding: "5px" }}>
                           <button
                             className="btn py-1 d-flex align-items-center justify-content-center gap-2 mx-auto"
                             style={{
                               minWidth: "47px",
                               height: "24px",
                               padding: "2px 7px",
                               display: "flex",
                               alignItems: "center",
                               justifyContent: "center",
                               gap: "4px",
                               fontSize: "10px",
                               fontWeight: "600",
                               lineHeight: "1",
                               cursor: "pointer",
                               background: "#ffffff",
                               color: "#39a852",
                               border: "1px solid #39a852",
                               borderRadius: "4px",
                               boxShadow: "none",
                             }}
                             onClick={() =>
                               settingshowspecific3(item.DemandGenerationID)
                             }
                           >
                            <img
                               src="/View-32.png"
                               alt="view"
                               width="15"
                               height="15"
                             />
                             <span>View</span>
                           </button>
                         </td>
                         {/* 21-09 */}
                         {isMaker && (
     <td style={{ padding: "10px", textAlign: "center" }}>
       <button
         onClick={() => handleEditDemand(item)}
         disabled={item.Status !== "SendBack"}
         style={{
           display: "flex",
           alignItems: "center",
           justifyContent: "center",
           gap: "5px",
           margin: "auto",
           padding: "6px 12px",
           background:
             item.Status === "SendBack" ? "#0D6EFD" : "rgba(141,141,141,0.97)",
           color: "#fff",
           border: "none",
           borderRadius: "6px",
           fontSize: "13px",
           fontWeight: "600",
           cursor: item.Status === "SendBack" ? "pointer" : "not-allowed",
         }}
       >
         <img src={Edit32WHITE} alt="Edit" style={{ width: "14px", height: "14px" }} />
         Edit
       </button>
     </td>
   )}
   {isMaker && (
     <td style={{ padding: "10px", textAlign: "center" }}>
       <button
         onClick={() => handleApproveDemand(item)}
         disabled={item.Status !== "SendBack"}
         style={{
           display: "flex",
           alignItems: "center",
           justifyContent: "center",
           gap: "5px",
           margin: "auto",
           padding: "6px 12px",
           background:
             item.Status === "SendBack" ? "#39B54A" : "rgba(141,141,141,0.97)",
           color: "#fff",
           border: "none",
           borderRadius: "6px",
           fontSize: "13px",
           fontWeight: "600",
           cursor: item.Status === "SendBack" ? "pointer" : "not-allowed",
         }}
       >
         <img src={Approved32} alt="Approve" style={{ width: "14px", height: "14px" }} />
         Approve
       </button>
     </td>
   )}
                       </tr>
                     </tbody>
                   ))}
                 </table>
   
   {/* 24-09 msg no datat found */}
    {/* {(!Array.isArray(currentBills) || currentBills.length === 0) && (
                     <div
                       style={{
                         position: "sticky",
                         left: 0,
                         width: "100%",
                         display: "flex",
                         justifyContent: "center",
                         alignItems: "center",
                         height: "100px",
                         boxSizing: "border-box",
                         backgroundColor: "#f9f9f9",
                         color: "black",
                         fontSize: "14px",
                         fontWeight: 500,
                       }}
                     >
                       No data available
                     </div>
                   )} */}
   
   
   {/* 19-10 add loader */}
   {listLoading ? (
     <div
       style={{
         width: "100%",
         height: "150px",
         display: "flex",
         flexDirection: "column",
         justifyContent: "center",
         alignItems: "center",
         gap: "10px",
         backgroundColor: "#ffffff",
         color: "#555",
         fontSize: "14px",
         fontWeight: 500,
         position: "sticky",
         left: 0,
       }}
     >
       <div className="dg-spinner" />
       Loading data...
     </div>
   ) : (
     (!Array.isArray(currentBills) || currentBills.length === 0) && (
       <div
         style={{
           position: "sticky",
           left: 0,
           width: "100%",
           display: "flex",
           justifyContent: "center",
           alignItems: "center",
           height: "100px",
           boxSizing: "border-box",
           backgroundColor: "#f9f9f9",
           color: "black",
           fontSize: "14px",
           fontWeight: 500,
         }}
       >
         No data available
       </div>
     )
   )}
       </div>            {/* ---- */}
   
               </div>
   
               <div
                 style={{
                   width: "100%",
                   display: "flex",
                   alignItems: "center",
                   justifyContent: "space-between",
                   marginTop: "15px",
                   padding: "10px 0",
                 }}
               >
                 {/* Showing Entries */}
                 <p
                   style={{
                     margin: 0,
                     fontSize: "13px",
                     color: "#333",
                     whiteSpace: "nowrap",
                   }}
                 >
                   Showing {filteredBills?.length === 0 ? 0 : indexOfFirstBill + 1}{" "}
                   to {Math.min(indexOfLastBill, filteredBills?.length || 0)} of{" "}
                   {filteredBills?.length || 0} entries
                 </p>
   
                 {/* Pagination */}
                 <div
                   style={{
                     display: "flex",
                     alignItems: "center",
                     gap: "18px",
                   }}
                 >
                   {/* Previous */}
                   <button
                     onClick={() =>
                       setCurrentPage((prev) => Math.max(prev - 1, 1))
                     }
                     disabled={currentPage === 1}
                     style={{
                       border: "none",
                       background: "transparent",
                       color: "#2ea4e7",
                       cursor: currentPage === 1 ? "not-allowed" : "pointer",
                       fontSize: "12px",
                       padding: 0,
                       opacity: currentPage === 1 ? 0.5 : 1,
                     }}
                   >
                     ‹ Previous
                   </button>
   
                   {/* Page Numbers */}
   
                   {/* ================= PAGE NUMBERS ================= */}
   
                   <div
                     style={{
                       display: "flex",
                       alignItems: "center",
                       gap: "20px",
                     }}
                   >
                     {getPageNumbers().map((pageNumber, index) => {
                       // ... ko button nahi banana
                       if (pageNumber === "...") {
                         return (
                           <span
                             key={`ellipsis-${index}`}
                             style={{
                               fontSize: "13px",
                               color: "#444",
                             }}
                           >
                             ...
                           </span>
                         );
                       }
   
                       return (
                         <button
                           key={pageNumber}
                           onClick={() => setCurrentPage(pageNumber)}
                           style={{
                             border: "none",
                             background: "transparent",
                             padding: 0,
                             color:
                               currentPage === pageNumber ? "#2ea4e7" : "#444",
                             cursor: "pointer",
                             fontSize: "13px",
                             fontWeight:
                               currentPage === pageNumber ? "600" : "400",
                             textDecoration:
                               currentPage === pageNumber ? "underline" : "none",
                           }}
                         >
                           {pageNumber}
                         </button>
                       );
                     })}
                   </div>
   
                   {/* Next */}
                   <button
                     onClick={() =>
                       setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                     }
                     disabled={currentPage === totalPages || totalPages === 0}
                     style={{
                       border: "none",
                       background: "transparent",
                       color: "#2ea4e7",
                       cursor:
                         currentPage === totalPages || totalPages === 0
                           ? "not-allowed"
                           : "pointer",
                       fontSize: "12px",
                       padding: 0,
                       opacity:
                         currentPage === totalPages || totalPages === 0 ? 0.5 : 1,
                     }}
                   >
                     Next ›
                   </button>
                 </div>
               </div>
             </div>
           </div>
         )}
   
         {showspecific === 3 && (
           <>
             <div
               className="col-12 m-auto"
               style={{ maxHeight: "85vh", overflow: "auto" }}
             >
               <div className="col-12 m-auto my-5 budgetContainer ">
                 <div
                   className="mt-3 d-flex justify-content-between"
                   style={{
                     position: "relative",
                     alignItems: "center",
                    
                   }}
                 >
                   {/* TITLE – LEFT */}
                   <div className="d-flex align-items-center gap-2 mb-3" style={{ paddingLeft: "150px" }} >
                      <img src="/Bill-Generation-32.png" alt="" width="26" height="26" />
    
                     <h5 className="m-0 fw-bold">Bill Slip</h5>
                   </div>
                   {/* BACK BUTTON – TOP RIGHT */}
                   <div className="col-4 pb-3 d-flex justify-content-end gap-2" style={{ paddingRight: "140px" }}>
                     <button
                       className="btn btn-primary d-flex align-items-center gap-2"
                       style={{
                         width: "110px",
                         // borderRadius: "999px",
                         //padding: "6px 22px",
                         fontSize: "12px",
                         zIndex: 10,
                         textAlign: "center",
                       }}
                       onClick={exportBillSlipPDF}
                       disabled={exportingBillSlipPDF}
                     >
                       {" "}
                       {exportingBillSlipPDF ? "Downloading..." : "Download PDF"}
                     </button>
                     <button
                       className="btn btn-danger d-flex align-items-center gap-2"
                       style={{
                         top: "12px",
                         right: "12px",
                         // borderRadius: "999px",
                         padding: "6px 15px",
                         fontSize: "12px",
                         zIndex: 10,
                       }}
                       onClick={BackFunction}
                     >
                       {" "}
                       Back{" "}
                     </button>
                   </div>
                 </div>
                 <div className="m-auto budgetElement">
                   {/* Heading */}
   
                   {/* TABLE CONTAINER */}
   
                   <div ref={billSlipRef}
                     style={{ width: "100%",
                       maxWidth: "100%", overflow: "visible", boxSizing: "border-box",  backgroundColor: "#fff",
                     }} >
                     {/* //28/10 */}
                      <div
     style={{
       display: "flex",
       justifyContent: "space-between",
       fontSize: "13px",
       fontWeight: 600,
       padding: "6px 4px",
       borderBottom: "1px solid #BFC5CC",
     }}
   >
     <span>
       UserName : {fetchSpecificDemandDeductionDetail?.[0]?.CreatedByName || "-"}
     </span>
     <span>
       Date : {formatSlipDate(
         fetchSpecificDemandDeductionDetail?.[0]?.UploadedOn || selectedBillData?.UploadedOn
       )}
     </span>
   </div>
                     {/* Table Header */}
                     <div
                       className="text-center text-white py-3"
                       style={{
                         background: "linear-gradient(90deg, #2b4ea1, #0aa2d6)",
                       }}
                     >
                       <h5 className="mb-1 fw-bold">Liability Register System</h5>
                       <div className="fw-semibold">
                         {" "}
                         (Maharashtra urban development department){" "}
                       </div>
                       <div className="fw-bold mt-1">
                         Payment Authority Year 2026-27
                       </div>
                       <div className="fw-bold mt-1">
                         {" "}
                         Agency - {selectedBillData?.PIU || "-"}{" "}
                       </div>
                     </div>
                     {/* Body */}
                     {/* //28/10 */}
                   <div className="bs-wrap">
                       <table
                        
                         style={{ fontSize: "14px", border: "none" }}
                       >
                         <tbody>
                           <tr>
                             <td
                               colSpan={2}
                               className="fw-bold text-center fs-6 p-1"
                             >
                               {" "}
                               Bill Slip for LRS
                             </td>
                           </tr>
                           {[
                             [
                               "Demand ID",
                               `${selectedBillData?.DemandGenerationID || selectedDemandID}`,
                             ],
                             [
                               "Date",
                               selectedBillData?.UploadedOn
                                 ? new Date(
                                     selectedBillData?.UploadedOn,
                                   ).toLocaleDateString()
                                 : "-",
                             ],
                             // ["Designation", `${selectedBillData.Designation}`],
                             // ["Bill Created By", `${selectedBillData.Email}`],
                             [
                               "Bill Created By",
                               `${selectedBillData.CreatedByAgencyFullName || "-"}`, //26-10
                             ],
                             // ["Budget Head", `${selectedBillData?.BudgetHead}`],
                             ["Project Name", `${selectedBillData?.ProjectName}`],
                             [
                               "Agency Name",
                               `${selectedBillData?.Agency_Name || "-"} `,
                             ],
                             ["Work Name", `${selectedBillData?.WorkName}`],
                             ...(selectedBillData?.BudgetHead
                               ? [["Head Name", `${selectedBillData?.BudgetHead}`]]
                               : []),
                             ["RA Bill", `${selectedBillData?.RABillNumber}`],
                             // ["CRC", `${selectedBillData?.CRC}`],
                             ...(selectedBillData?.Scheme === "Budget"
     ? [["CRC", `${selectedBillData?.CRC || "-"}`]]
     : []),
                             [
                               "PhysicalProgress",
                               `${selectedBillData?.PhysicalProgress}`,
                             ],
   
                             // ["Voucher No.", `${selectedBillData?.VoucherNo}`],
                             // ["Road Type", `${selectedBillData?.RoadType}`],
                             // ["Package No/Agreement No", `${selectedBillData?.AgreementUID}`],
                             // ["Bill No", `${selectedBillData?.RABillNumber}`],
                             // ["Funding Head", `${selectedBillData?.BudgetID}`],
                             // ["Work Name", `${selectedBillData?.ProjectName}`],
                           ].map(([label, value], index) => (
                             <tr
                               key={index}
                               style={{ border: "1.5px solid #1190CA" }}
                             >
                               <td
                                 className="text-start"
                                 style={{
                                   width: "30%",
                                   backgroundColor: "#EAF3FB",
                                   fontWeight: 500,
                                   padding: "6px 10px",
                                   borderRight: "1.5px solid #1190CA",
                                 }}
                               >
                                 {label}{" "}
                               </td>
                               <td
                                 className="text-start"
                                 style={{
                                   width: "70%",
                                   padding: "6px 10px",
                                   backgroundColor: "#FFFFFF",
                                 }}
                               >
                                 {" "}
                                 {value}
                               </td>
                             </tr>
                           ))}
   
                           {/* //28/10 */}
                           
   {[
     ["Bill Amount", selectedBillData?.BillAmount ?? "-"],
     [
       "Bill Amount in Words",
       numberToWords(selectedBillData?.BillAmount),
     ],
     ["Net Payable", selectedBillData?.NetPayableAmount ?? "-"],
     ["Deduction", selectedBillData?.DeductionAmount ?? "-"],
   ].map(([label, value], index) => (
     <tr key={`amount-${index}`}>
       <td
         className="text-start"
         style={{
           width: "30%",
           backgroundColor: "#EAF3FB",
           fontWeight: 600,
           padding: "6px 10px",
           borderRight: "1.5px solid #1190CA",
         }}
       >
         {label}
       </td>
       <td
         className="text-start"
         style={{
           width: "70%",
           padding: "6px 10px",
           backgroundColor: "#FFFFFF",
         }}
       >
         {value}
       </td>
     </tr>
   ))}
   
                         </tbody>
                       </table>
                       <table
                      
                         style={{
                           borderCollapse: "separate",
                           borderSpacing: 0,
                           width: "100%",
                         }}
                       >
                         <tbody>
                           <tr>
                             {/* <td
                               className="text-start"
                               style={{
                                 width: "30%",
                                 border: "1px solid #000",
                                 padding: "6px 8px",
                               }}
                             >
                               Total Bill Amount
                             </td>
                             <td
                               className="text-start"
                               style={{
                                 width: "23%",
                                 border: "1px solid #000",
                                 padding: "6px 8px",
                               }}
                             >
                               Net Payable
                             </td>
                             <td
                               className="text-start"
                               style={{
                                 width: "23%",
                                 border: "1px solid #000",
                                 padding: "6px 8px",
                               }}
                             >
                               Deduction
                             </td> */}
                           </tr>
                           <tr>
                             {/* <td
                               className="text-start"
                               style={{
                                 border: "1px solid #000",
                                 padding: "6px 8px",
                               }}
                             >
                               {selectedBillData?.BillAmount}
                             </td> */}
                             {/* <td
                               className="text-start"
                               style={{
                                 border: "1px solid #000",
                                 padding: "6px 8px",
                               }}
                             > */}
                               {/* {selectedBillData?.NetPayableAmount}
                             </td>
                             <td
                               className="text-start"
                               style={{
                                 border: "1px solid #000",
                                 padding: "6px 8px",
                               }}
                             >
                               {selectedBillData?.DeductionAmount}
                             </td> */}
                           </tr>
                         </tbody>
                       </table>
   
                       {/* Vendor Details */}
                       <table
                        
                         style={{
                           width: "100%",
                           borderCollapse: "collapse",
                           fontSize: "14px",
                         }}
                       >
                         <tbody>
                           {/* Section Title */}
                           <tr
                             style={{
                               border: "1.5px solid #1190CA",
                               backgroundColor: "#EAF3FB",
                             }}
                           >
                             <td
                               colSpan="6"
                               style={{
                                 padding: "8px 10px",
                                 fontWeight: 600,
                                 textAlign: "center",
                               }}
                             >
                               {" "}
                               Vendor Details
                             </td>
                           </tr>
   
                           {/* Column Headers */}
                           <tr style={{ border: "1.5px solid #1190CA" }}>
                             <td
                               style={{
                                 padding: "6px 8px",
                                 fontWeight: 500,
                                 backgroundColor: "#1190CA",
                                 color: "white",
                               }}
                             >
                               {" "}
                               Vendor Name
                             </td>
                             <td
                               style={{
                                 padding: "6px 8px",
                                 fontWeight: 500,
                                 backgroundColor: "#1190CA",
                                 color: "white",
                               }}
                             >
                               IFSC Code
                             </td>
                             <td
                               style={{
                                 padding: "6px 8px",
                                 fontWeight: 500,
                                 backgroundColor: "#1190CA",
                                 color: "white",
                               }}
                             >
                               {" "}
                               Branch Name{" "}
                             </td>
                             <td  style={{
                                 padding: "6px 8px",
                                 fontWeight: 500,
                                 backgroundColor: "#1190CA",
                                 color: "white",
                               }} >
                               {" "}
                               Account Number
                             </td>
                             <td
                               style={{
                                 padding: "6px 8px",
                                 fontWeight: 500,
                                 backgroundColor: "#1190CA",
                                 color: "white",
                               }}
                             >
                               {" "}
                               Amount{" "}
                             </td>
                           </tr>
                           {fetchSpecificDemandDeductionDetail &&
                             fetchSpecificDemandDeductionDetail
                               .filter(
                                 (val) =>
                                   val.TypeOfAmount == "Total Amount Payable",
                               )
                               .map((val, index) => {
                                 return (
                                   <>
                                     <tr
                                       style={{ border: "1.5px solid #1190CA" }}
                                       key={index}
                                     >
                                       <td
                                         style={{
                                           padding: "6px 8px",
                                           backgroundColor: "white",
                                         }}
                                       >
                                         {val.Vendor_Company_Name}
                                       </td>
                                       <td
                                         style={{
                                           padding: "6px 8px",
                                           backgroundColor: "white",
                                         }}
                                       >
                                         {" "}
                                         {val.Bank_IFSC_Code}{" "}
                                       </td>
                                       <td
                                         style={{
                                           padding: "6px 8px",
                                           backgroundColor: "white",
                                         }}
                                       >
                                         {val.Branch_Name}
                                       </td>
                                       <td
                                         style={{
                                           padding: "6px 8px",
                                           backgroundColor: "white",
                                         }}
                                       >
                                         {" "}
                                         {val.Bank_Account_Number}
                                       </td>
                                       <td
                                         style={{
                                           padding: "6px 8px",
                                           backgroundColor: "white",
                                         }}
                                       >
                                         {val.TotalAmount}
                                       </td>
                                     </tr>
                                   </>
                                 );
                               })}
                           {/* <tr style={{ border: "1.5px solid #1190CA" }}>
                             <td
                             >
                               Shivsai Construction
                             </td>
                             <td className='border border-dark'>AKIPS8199N</td>
                             <td className='border border-dark'>MAHB0001302</td>
                             <td className='border border-dark'>BANK OF MAHARASHTRA, GHODBUNDER ROAD</td>
                             <td className='border border-dark'>2,43,991.0</td>
                             <td className='border border-dark'> 2,43,991.0</td>
                           </tr> */}
   
                           {/* Total */}
                           <tr style={{ border: "1.5px solid #1190CA" }}>
                             <td
                               style={{
                                 padding: "6px 8px",
                                 backgroundColor: "#EAF3FB",
                                 fontWeight: 500,
                               }}
                               colSpan={4}
                             >
                               {" "}
                               Total
                             </td>
                             <td className="border border-dark">
                               {selectedBillData?.NetPayableAmount}{" "}
                             </td>
                           </tr>
                         </tbody>
                       </table>
                       <table
   
                         style={{ width: "100%", borderCollapse: "collapse" }}
                       >
                         <thead>
                           <tr
                             style={{
                               border: "1.5px solid #1190CA",
                               backgroundColor: "#2D79D9",
                               color:"white"
                             }}
                           >
                             <td
                               colSpan="6"
                               style={{
                                 padding: "8px 10px",
                                 fontWeight: 600,
                                 textAlign: "center",
                                 color: "white",
                               }}
                             >
                               {" "}
                               Deduction Amount Details
                             </td>
                           </tr>
                           <tr
                             style={{
                               color: "white",
                               backgroundColor: "#2D79D9",
                               height: "3rem",
                             }}
                           >
                             <th style={{ minWidth: "60px", padding: "8px" }}>
                               {" "}
                               Sr No{" "}
                             </th>
                             <th style={{ minWidth: "60px", padding: "8px" }}>
                               {" "}
                               Deduction Type{" "}
                             </th>
                             <th style={{ minWidth: "60px", padding: "8px" }}>
                               {" "}                      
                               Deduction Amount{" "}
                             </th>
                             <th style={{ minWidth: "60px", padding: "8px" }}>
                               {" "}
                               Amount Number
                             </th>
                             <th style={{ minWidth: "60px", padding: "8px" }}>
                               {" "}
                               IFSC{" "}
                             </th>
                           </tr>
                         </thead>
                         <tbody>
                           {fetchSpecificDemandDeductionDetail.filter(
                             (val) => val.TypeOfAmount != "Total Amount Payable",
                           )?.length == 0 ? (
                             <tr>
                               <td
                                 colSpan="30"
                                 style={{
                                   textAlign: "center",
                                   padding: "20px",
                                   backgroundColor: "#f9f9f9",
                                 }}
                               >
                                 {" "}
                                 No Deduction  Added
                               </td>
                             </tr>
                           ) : (
                             fetchSpecificDemandDeductionDetail
                               .filter(
                                 (val) =>
                                   val.TypeOfAmount != "Total Amount Payable",
                               )
                               .map((technicalInwards, index) => {
                                 //28/10
                                 const bgColor =
                                   index % 2 === 0 ? "#E5F4FB" : "#CEE4F1";
                                 return (
                                   <tr
                                     className="px-3"
                                     key={index}
                                     style={{
                                       borderBottom: "1px solid #3b409e",
                                       backgroundColor: bgColor,
                                     }}
                                   >
                                     <td
                                       style={{
                                         fontSize: "12px",
                                         padding: "5px",
                                       }}
                                     >
                                       {index + 1}
                                     </td>
                                     <td
                                       style={{
                                         fontSize: "12px",
                                         padding: "5px",
                                       }}
                                     >
                                       {" "}
                                       {technicalInwards.TypeOfAmount}{" "}
                                     </td>
                                     <td
                                       style={{
                                         fontSize: "12px",
                                         padding: "5px",
                                       }}
                                     >
                                       {" "}
                                       {technicalInwards.TotalAmount}
                                     </td>
                                     <td
                                       style={{
                                         fontSize: "12px",
                                         padding: "5px",
                                       }}
                                     >
                                       {" "}
                                       {technicalInwards.Bank_Account_Number}
                                     </td>
                                     <td
                                       style={{
                                         fontSize: "12px",
                                         padding: "5px",
                                       }}
                                     >
                                       {technicalInwards.Bank_IFSC_Code}
                                     </td>
                                   </tr>
                                 );
                               })
                           )}
                           {/* 30-10 */}
                           {Number(selectedBillData?.DeductionAmount || 0) > 0 && (
                           <tr
                             style={{
                               border: "1.5px solid #1190CA",
                               fontWeight: 600,
                               background: "white",
                             }}
                           >
                             {/* //28/10 */}
                              <td colSpan="2"
     style={{ padding: "6px 8px", textAlign: "right" }}
   >
     {" "}
     Total
   </td>
   <td colSpan="3" style={{ padding: "6px 8px", textAlign: "left" }}>
     {selectedBillData?.DeductionAmount}
   </td>
                           </tr>
                           // 28-10
                           )}
                         </tbody>
                       </table>
   {/* 
   //28/10 */}
   {/* Bill Copy link */}
   {d.UploadBillCopy && (
     <table
       style={{
         width: "100%",
         tableLayout: "fixed",
         borderCollapse: "separate",
         borderSpacing: "1px",
         backgroundColor: "#000",
         marginTop: "8px",
       }}
     >
       <tbody>
         <tr>
           <td
             style={{
               ...slipCell,
               backgroundColor: "#EAF1FB",
               textAlign: "center",
               fontSize: "12px",
             }}
           >
            <a
     href={`${apiurl}/BillCopyDocsImages/${encodeURIComponent(d.UploadBillCopy)}`}
     target="_blank"
     rel="noopener noreferrer"
     style={{
       color: "#000",
       textDecoration: "underline",
       cursor: "pointer",
       fontWeight: 600,
     }}
   >
     Bill Copy ↗
   </a>
           </td>
         </tr>
       </tbody>
     </table>
   )}
                       {/* Signature grid */}
                       {/* <table style={{width:"100%"}}>
                                               <tbody>
                                                   {[
                                                       [
                                                           {
                                                               role: "MAKER",
                                                               rDate: fetchSpecificDemandDeductionDetail[0]
                                                                   ?.UploadedOn
                                                                   ? fetchSpecificDemandDeductionDetail[0].UploadedOn.split(
                                                                       "T",
                                                                   )[0]
                                                                   : "-",
                                                               aDate: fetchSpecificDemandDeductionDetail[0]
                                                                   ?.GM_Approval_Date
                                                                   ? fetchSpecificDemandDeductionDetail[0].GM_Approval_Date.split(
                                                                       "T",
                                                                   )[0]
                                                                   : "-",
                                                           },
                                                           {
                                                               role: "Checker",
                                                               rDate: fetchSpecificDemandDeductionDetail[0]
                                                                   ?.GM_Approval_Date
                                                                   ? fetchSpecificDemandDeductionDetail[0].GM_Approval_Date.split(
                                                                       "T",
                                                                   )[0]
                                                                   : "-",
                                                               aDate: fetchSpecificDemandDeductionDetail[0]
                                                                   ?.Acnt_Approval_Date
                                                                   ? fetchSpecificDemandDeductionDetail[0].Acnt_Approval_Date.split(
                                                                       "T",
                                                                   )[0]
                                                                   : "-",
                                                           },
                                                       ],
                                                   ].map((row, rowIndex) => (
                                                       <div key={rowIndex} className="card d-flex flex-row ">
                                                           {row.map((cell, colIndex) => (
                                                               <div className="col-6 text-start mt-5 px-5 mb-2" key={colIndex}>
                                                                   <div><strong>Signature :</strong></div>
                                                                   <div>Received Date : {cell.rDate}</div>
                                                                   <div>Approved Date : {cell.aDate}</div>
                                                                   <div>Designation : {cell.role}</div>
                                                               </div>
                                                           ))}
                                                       </div>
                                                   ))}
                                               </tbody>
                                           </table> */}
   {/* //28/10 */}
                      <table
     className="bs-sign"
     style={{
       width: "100%",
       borderCollapse: "collapse",
       marginTop: "25px",
       tableLayout: "fixed",
     }}
   >
                         <tbody style={{}}>
                           {Array.from({
                             length: Math.ceil(signatureData.length / 3),
                           }).map((_, rowIndex) => (
                             <tr key={rowIndex}>
                               {signatureData
                                 .slice(rowIndex * 3, rowIndex * 3 + 3)
                                 .map((item, index) => (
                                   <td
                                     key={index}
                                     style={{
                                       //border: "3px solid black",
                                       boxShadow:
                                         "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 1px 1px",
                                       width: "33.33%",
                                       height: "95px",
                                       background: "#f4f8fd",
                                       textAlign: "center",
                                       verticalAlign: "middle",
                                       padding: "8px",
                                       fontFamily: "Times New Roman",
                                       lineHeight: "1.3",
                                     }}
                                   >
                                     <div
                                       style={{
                                         fontWeight: "bold",
                                         fontSize: "14px",
                                         marginBottom: "18px",
                                       }}
                                     >
                                       {" "}
                                       Signature :
                                     </div>
                                     <div
                                       style={{
                                         fontSize: "12px",
                                         marginBottom: "5px",
                                         color: "#424141",
                                       }}
                                     >
                                       {item.label} : {item.date}{" "}
                                     </div>
                                     <div
                                       style={{
                                         fontSize: "12px",
                                         color: "#393838",
                                       }}
                                     >
                                       {" "}
                                       UserName :{item?.FullName || "-"}
                                     </div>
   
                                     <div
                                       style={{
                                         fontSize: "12px",
                                         color: "#393838",
                                       }}
                                     >
                                       {" "}
                                       Designation : {item.designation}
                                     </div>
                                   </td>
                                 ))}
   
                               {rowIndex ===
                                 Math.ceil(signatureData.length / 3) - 1 &&
                                 signatureData.length % 3 !== 0 &&
                                 Array.from({
                                   length: 3 - (signatureData.length % 3),
                                 }).map((_, i) => (
                                   <td
                                     key={`empty-${i}`}
                                     style={{
                                       border: "2px solid #000",
                                       width: "33.33%",
                                       height: "145px",
                                       backgroundColor: "#eef2f7",
                                     }}
                                   ></td>
                                 ))}
                             </tr>
                           ))}
                         </tbody>
                       </table>
   
                       {/* Footer */}
                       <div
                         className="row g-0"
                         style={{
                           borderTop: "1.5px solid #1190CA",
                           minHeight: "120px",
                           padding: "20px 0",
                         }}
                       >
                         <div
                           className="col-2 d-flex flex-column justify-content-center"
                           style={{ alignItems: "flex-start" }}
                         >
                           <div
                             style={{
                               width: "130px",
                               height: "130px",
                               border: "1px solid #BFC5CC",
                               padding: "4px",
                               backgroundColor: "#fff",
                             }}
                           >
                             <img
                               src="/sample-qr-code.png"
                               alt="Bill QR Code"
                               style={{
                                 width: "100%",
                                 height: "100%",
                                 objectFit: "contain",
                               }}
                             />
                           </div>
                           <div
                             style={{
                               fontSize: "14px",
                               marginTop: "6px",
                               fontWeight: "500",
                             }}
                           >
                             {" "}
                             Bill QR Code
                           </div>
                         </div>
                         {/* Center text – TOP aligned */}
                         <div
                           className="col-8 px-3"
                           style={{
                             fontSize: "13px",
                             color: "#333",
                             lineHeight: "1.4",
                             fontWeight: "500",
                             textAlign: "justify",
                             alignSelf: "flex-start",
                             marginTop: "10px",
                           }}
                         ></div>
                         {/* Work QR - RIGHT EDGE */}
                         <div
                           className="col-2 d-flex flex-column justify-content-center"
                           style={{ alignItems: "flex-end" }}
                         >
                           <div
                             style={{
                               width: "130px",
                               height: "130px",
                               border: "1px solid #BFC5CC",
                               padding: "4px",
                               backgroundColor: "#fff",
                             }}
                           >
                             <img
                               src="/sample-qr-code.png"
                               alt="Work QR Code"
                               style={{
                                 width: "100%",
                                 height: "100%",
                                 objectFit: "contain",
                               }}
                             />
                           </div>
                           <div
                             style={{
                               fontSize: "14px",
                               marginTop: "6px",
                               fontWeight: "500",
                             }}
                           >
                             Work QR Code{" "}
                           </div>
                         </div>
                       </div>
                        {/* Print Date */}
                             {/* //28/10 */}
   <div
     style={{
       display: "flex",
       justifyContent: "flex-end",
       padding: "10px 4px",
       fontSize: "12px",
       fontWeight: 600,
       color: "#000",
       borderTop: "1px solid #BFC5CC",
       whiteSpace:"nowrap"
     }}
   >
     Print Date: {getPrintDate()}
   </div>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
           </>
         )}
       
       
       
       </div></div>
        ) : (
      <DemandGeneration
        isEdit={true}
        billData={editBillData}
        onSuccess={() => {
          setShowEditForm(false);
          getDemandGenerationList(); // refresh list
        }}
        onCancel={() => {
          setShowEditForm(false);
        }}
      />
    )}
    </>
  );
};

export default ViewDemandGeneration;

